// Ported from src/scripts/data/icons.js — badge-check verification mark
// Original used fill="#2f9bff"; uses currentColor so it themes via tokens
export function Verify({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2l2.4 1.8 3-.2 1 2.8 2.6 1.5-.8 2.9.8 2.9-2.6 1.5-1 2.8-3-.2L12 22l-2.4-1.9-3 .2-1-2.8L3 16l.8-2.9L3 10.2 5.6 8.7l1-2.8 3 .2z" />
      <path d="m8.5 12 2.4 2.4 4.6-4.8" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
